import React from "react";

import classnames from "classnames";

const INDICATORS = [
	{ name: "Bollinger Bands", onClickParams: { type: "BollingerBand" } },
	{ name: "MACD", onClickParams: { type: "MACD" } },
	{ name: "Moving Average - Exponential", onClickParams: { type: "EMA" } },
	{ name: "Moving Average - Simple", onClickParams: { type: "SMA" } },
	{ name: "RSI", onClickParams: { type: "RSI" } },
	{ name: "Stochastics", onClickParams: { type: "FullStochasticOscillator" } },
];

export default class Indicators extends React.Component {
	render() {
		var classes = classnames({
			"dropdown": true,
			"open": this.props.showDropDown
		});
		var { onIndicatorAdd } = this.props;

		return (
			<div className="indicators" data-intro="add indicators to a chart">
				<div className={classes}  >
					<button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1"
							data-toggle="dropdown" onClick={this.props.onDropDownToggle}>
						Indicators <span className="caret"></span>
					</button>
					<ul className="dropdown-menu">
						{INDICATORS.map((each, idx) => 
							<li key={idx}>
								<a tabIndex="-1" href="#"
									onClick={onIndicatorAdd.bind(null, each.onClickParams.type)}>{each.name}</a>
							</li>)}
					</ul>
				</div>
			</div>
		);
	}
}

/*
						<li className=" search">
							<form className="navbar-form navbar-left" role="search">
								<div className="form-group">
									<input type="text" className="form-control" placeholder="Filter" />
								</div>
							</form>
						</li>
*/


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/Indicators.jsx
 **/